export default "__VITE_ASSET__0rdoBqiI__"